import { Box, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface TableStateMessageProps {
  message: string;
  isError?: boolean;
}

export default function TableStateMessage({
  message,
  isError = false,
}: TableStateMessageProps) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "56px",
        left: 0,
        right: 0,
        py: 3,
        display: "flex",
        justifyContent: "center",
        zIndex: 1,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          color: isError ? "error.main" : "text.secondary",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        {isError ? (
          <ErrorIcon fontSize="medium" />
        ) : (
          <InfoOutlinedIcon fontSize="medium" />
        )}
        {message}
      </Typography>
    </Box>
  );
}